import React from "react";
import Label from "../../atoms/label/label";
import "./labelAndValue.sass";

export interface ILabelAndValue {
  labelText: string;
  valueText: string;
}

const LabelAndValue: React.FC<ILabelAndValue> = ({labelText, valueText}) => {
  return (
    <div className="label-and-value">
      <Label text={labelText} isRequired={false} />
      <div> {valueText}</div>
    </div>
  );
};

export default LabelAndValue;
